import { categorySchema } from '@/entities/shared/category/category';
import { CATEGORY_LABELS } from '@/entities/shared/category/category-labels';
import { FilterSelect } from '@/shared/components/filter-select';
import { FiltersBar } from '@/shared/components/filters-bar';
import { msg } from '@/shared/i18n/msg';
import { useTranslation } from '@/shared/i18n/use-translation';
import type { useShoppingList } from '../hooks/use-shopping-list';

type ShoppingFiltersProps = {
  readonly shopping: ReturnType<typeof useShoppingList>;
};

export function ShoppingFilters({ shopping }: ShoppingFiltersProps) {
  const { t } = useTranslation();
  const { criteria, stores } = shopping;
  return (
    <FiltersBar
      active={[criteria.store, criteria.category].filter(Boolean).length}
      onClear={() => {
        shopping.setStore('');
        shopping.setCategory('');
      }}
    >
      {stores.length > 0 && (
        <FilterSelect
          label={t('Store')}
          value={criteria.store}
          onChange={shopping.setStore}
          options={[
            { value: '', label: msg('All stores') },
            ...stores.map((store) => ({
              value: store.value,
              label: store.count > 0 ? `${t(store.label)} (${store.count})` : t(store.label),
            })),
          ]}
        />
      )}
      <FilterSelect
        label={t('Category')}
        value={criteria.category}
        onChange={shopping.setCategory}
        options={[
          { value: '', label: msg('All categories') },
          ...categorySchema.options.map((value) => ({ value, label: CATEGORY_LABELS[value].label })),
        ]}
      />
    </FiltersBar>
  );
}
